<template>
	<div>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du netlink ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<br />
		<h6 class="th-sticky" style="color: #a9a9a9">
			Résultat total: {{ rowNum }} / {{ netlink.length }}
		</h6>
		<br />
		<vs-table
			v-if="$acl.check('accountmanager')"
			:data="netlink"
			pagination
			:max-items="25"
			stripe
			:max-height="tableHeight + 'px'"
			:key="refreshList"
			id="tb-netlink"
		>
			<template slot="thead">
				<vs-th class="th-sticky pdl0" v-if="!readOnly">CLIENT</vs-th>
				<vs-th class="th-sticky pdl0" sort-key="contract_id" v-if="!readOnly"
					>Contrat<br />N°</vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="url_bought">Lien acheté</vs-th>
				<vs-th class="th-sticky pdl0" sort-key="landing_page"
					>Landing page</vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="provider_name"
					>Prestataire</vs-th
				>
				<vs-th class="th-sticky" sort-key="price" style="width: 50px"
					><div class="w-full" style="text-align: right !important">
						PRIX
					</div></vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="anchor_type">Type Ancre</vs-th>
				<vs-th class="th-sticky pdl0" sort-key="anchor_type">Ancre</vs-th>
				<vs-th class="th-sticky pdl0" sort-key="link_type">Type Lien</vs-th>
				<vs-th class="th-sticky pdl0" sort-key="link_type">Période</vs-th>
				<vs-th
					class="th-sticky pdl0"
					sort-key="creation_date"
					style="text-align: center"
					>Date Création</vs-th
				>
				<!-- <vs-th class="th-sticky pdl0" sort-key="domain_authority"
					><div style="margin-left: -5px">DA</div></vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="page_authority"
					><div style="margin-left: -5px">PA</div></vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="trust_flow"
					><div style="margin-left: -5px">TF</div></vs-th
				>
				<vs-th class="th-sticky pdl0" sort-key="citation_flow"
					><div style="margin-left: -5px">CF</div></vs-th
				>
				<vs-th class="th-sticky text-center pdl0" sort-key="ref_domains"
					>Domaines<br />Réferrents</vs-th
				>
				<vs-th class="th-sticky text-center pdl0" sort-key="external_links"
					>Liens<br />Entrants</vs-th
				> -->
				<vs-th class="th-sticky" sort-key="status"
					><div class="w-full text-center">STATUT</div></vs-th
				>
				<vs-th class="th-sticky" v-if="!readOnly"></vs-th>
				<vs-th
					class="th-sticky"
					v-if="$acl.check('sadmin') && !readOnly"
				></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(oneNetlink, index) in data">
					<div v-show="false">
						{{ (rowNum = data.length) }}
					</div>
					<vs-td :data="oneNetlink.society_id" v-if="!readOnly">
						<span
							@click="
								displaySocietyPopup(getSocietyById(oneNetlink.society_id))
							"
							class="hvr-underline hvr-underline-out"
							>{{ getSocietyName(oneNetlink.society_id) }}</span
						>
					</vs-td>
					<vs-td
						:data="oneNetlink.contract_id"
						v-if="!readOnly"
						class="text-center"
					>
						<span
							@click="displayContractPopup(oneNetlink.contract_id)"
							class="hvr-underline hvr-underline-out"
							>{{ oneNetlink.contract_id ? oneNetlink.contract_id : " " }}</span
						>
					</vs-td>
					<vs-td :data="oneNetlink.url_bought"
						><a
							class="hvr-underline hvr-underline-out"
							:href="oneNetlink.url_bought"
							target="_blank"
							>{{ oneNetlink.url_bought }}</a
						></vs-td
					>
					<vs-td :data="oneNetlink.landing_page">
						<a
							class="hvr-underline hvr-underline-out"
							:href="oneNetlink.landing_page"
							target="_blank"
							>{{ oneNetlink.landing_page }}</a
						>
					</vs-td>
					<vs-td :data="oneNetlink.provider_name">
						{{ oneNetlink.provider_name }}
					</vs-td>
					<vs-td
						:data="oneNetlink.price"
						style="width: 50px; padding-right: 11px"
						class="pdl0 text-right"
					>
						{{ oneNetlink.price }}€
					</vs-td>

					<vs-td :data="oneNetlink.anchor_type">{{
						getNetlinkAnchorType(oneNetlink.anchor_type)
					}}</vs-td>
					<vs-td :data="oneNetlink.anchor_type">{{ oneNetlink.anchor }}</vs-td>
					<vs-td :data="oneNetlink.link_type">{{
						getNetlinkTypeName(oneNetlink.link_type)
					}}</vs-td>
					<vs-td :data="oneNetlink.period_date" class="text-center pdl0">
						{{
							oneNetlink.period_date ? getInMonth(oneNetlink.period_date) : ""
						}}</vs-td
					>
					<vs-td :data="oneNetlink.creation_date" class="text-center pdl0">
						{{
							oneNetlink.creation_date
								? getDateToFrenchFormat(
										oneNetlink.creation_date.substring(0, 10)
								  )
								: getDateToFrenchFormat(
										getPurchaseIdToPurchaseDate(oneNetlink.purchase_id)
								  )
						}}</vs-td
					>

					<!-- <vs-td
						:data="oneNetlink.domain_authority"
						class="pdl0"
						style="width: 50px; text-align: right"
						><vs-spacer /><vs-chip
							><strong>{{ oneNetlink.domain_authority }}</strong></vs-chip
						><vs-spacer
					/></vs-td>
					<vs-td
						:data="oneNetlink.page_authority"
						class="pdl0"
						style="width: 50px; text-align: right"
						><vs-spacer /><vs-chip
							><strong>{{ oneNetlink.page_authority }}</strong></vs-chip
						><vs-spacer
					/></vs-td>
					<vs-td
						:data="oneNetlink.trust_flow"
						class="pdl0"
						style="width: 50px; text-align: right"
						><vs-spacer /><vs-chip
							><strong>{{ oneNetlink.trust_flow }}</strong></vs-chip
						><vs-spacer
					/></vs-td>
					<vs-td
						:data="oneNetlink.citation_flow"
						class="pdl0"
						style="width: 50px; text-align: right"
						><vs-spacer /><vs-chip
							><strong>{{ oneNetlink.citation_flow }}</strong></vs-chip
						><vs-spacer
					/></vs-td>
					<vs-td
						:data="oneNetlink.ref_domains"
						class="pdl0"
						style="width: 100px"
						><div style="display: flex; justify-content: center">
							<vs-spacer /><vs-chip style="margin-right: 0 !important"
								><strong>{{
									formatThousandNumb(oneNetlink.ref_domains)
								}}</strong></vs-chip
							><vs-spacer /></div
					></vs-td>
					<vs-td
						:data="oneNetlink.external_links"
						class="pdl0"
						style="width: 100px"
						><div style="display: flex; justify-content: center">
							<vs-spacer /><vs-chip style="margin-right: 0 !important"
								><strong>{{
									formatThousandNumb(oneNetlink.external_links)
								}}</strong></vs-chip
							><vs-spacer /></div
					></vs-td> -->

					<vs-td :data="oneNetlink.status" style="text-align: center">
						<vs-chip
							style="width: 80px"
							:color="getNetlinkStatusColor(oneNetlink.status)"
							class="ml-2"
							>{{ getNetlinkStatus(oneNetlink.status) }}</vs-chip
						>
					</vs-td>
					<vs-td v-if="!readOnly">
						<vx-tooltip text="Modifier" position="top">
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-edit-2"
								@click="
									updateNetlink(
										oneNetlink,
										getSocietyName(oneNetlink.society_id)
									)
								"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="$acl.check('sadmin') && !readOnly">
						<vx-tooltip text="Effacer" position="top">
							<vs-button
								size="large"
								color="danger"
								type="flat"
								icon-pack="feather"
								icon="icon-trash-2"
								@click="displayValidationPopup(oneNetlink)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<vs-table
			v-if="!$acl.check('accountmanager')"
			:data="resultByMonth"
			noDataText=""
			stripe
			auto-resize
			:key="refreshList"
		>
			<vs-tr
				:key="index"
				v-for="(resultNetlinkByMouth, index) in resultByMonth"
			>
				<vs-th class="thead-client">{{ resultNetlinkByMouth.dateYM }}</vs-th>

				<template>
					<vs-td>
						<vs-table
							:data="resultNetlinkByMouth.resultClient"
							pagination
							:max-items="25"
							stripe
							auto-resize
							class="table-client"
						>
							<template slot="thead">
								<vs-th>Client</vs-th>
								<vs-th sort-key="contract_id">N° Contrat</vs-th>
								<vs-th sort-key="url_bought">Lien acheté</vs-th>
								<vs-th sort-key="landing_page">Landing page</vs-th>
								<vs-th sort-key="anchor_type">Type Ancre</vs-th>
								<vs-th sort-key="link_type">Type Lien</vs-th>
								<vs-th sort-key="creation_date">Date Achat/Création</vs-th>
								<vs-th sort-key="status">Statut</vs-th>
							</template>

							<template>
								<vs-tr
									:key="index"
									v-for="(
										oneNetlink, index
									) in resultNetlinkByMouth.resultClient"
								>
									<vs-td :data="oneNetlink.society_id">
										<span>{{ getSocietyName(oneNetlink.society_id) }}</span>
									</vs-td>
									<vs-td :data="oneNetlink.contract_id">
										<span>{{
											oneNetlink.contract_id ? oneNetlink.contract_id : " "
										}}</span>
									</vs-td>
									<vs-td :data="oneNetlink.url_bought"
										><a
											class="hvr-underline hvr-underline-out"
											:href="oneNetlink.url_bought"
											target="_blank"
											>{{ oneNetlink.url_bought }}</a
										></vs-td
									>
									<vs-td :data="oneNetlink.landing_page">
										<a
											class="hvr-underline hvr-underline-out"
											:href="oneNetlink.landing_page"
											target="_blank"
											>{{ oneNetlink.landing_page }}</a
										>
									</vs-td>

									<vs-td :data="oneNetlink.anchor_type">{{
										getNetlinkAnchorType(oneNetlink.anchor_type)
									}}</vs-td>
									<vs-td :data="oneNetlink.link_type">{{
										getNetlinkTypeName(oneNetlink.link_type)
									}}</vs-td>
									<vs-td :data="oneNetlink.creation_date">
										{{
											oneNetlink.creation_date
												? getDateToFrenchFormat(
														oneNetlink.creation_date.substring(0, 10)
												  )
												: getDateToFrenchFormat(
														getPurchaseIdToPurchaseDate(oneNetlink.purchase_id)
												  )
										}}</vs-td
									>

									<vs-td :data="oneNetlink.status">
										<vs-chip
											style="width: 80px"
											:color="getNetlinkStatusColor(oneNetlink.status)"
											class="ml-2"
											>{{ getNetlinkStatus(oneNetlink.status) }}</vs-chip
										>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</vs-td>
				</template>
			</vs-tr>
		</vs-table>
	</div>
</template>

<script>
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Netlink from "@/entities/Netlink";

export default {
	name: "NetlinkTable",
	props: {
		netlink: Array,
		listResult: String,
		netlinkTypes: {
			type: Array,
			default: null,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			showValidationPopup: false,
			netlinkToDelete: null,
			basicImgUrl: "task_default.png",
			societyImageList: [],
			idClient: "",
			rowNum: 0,
			resultByMonth: [],
			refreshList: 0,
		};
	},
	created() {
		this.getAllNetlinkTypes();
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		this.getAllPurchases();
		this.getResultClientByMouth();
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		netlink_types: () => {
			return store.state.netlink_types;
		},
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		purchases: () => {
			return store.state.purchases;
		},
	},
	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.28 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.28 * this.windowHeigth
				);
			});
		});
	},
	watch: {
		isFilterDown: function () {
			//console.log("FILTER DOWN TIGGER0", document.getElementById("filterCardNet").clientHeight);
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("filterCardNet").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.28 * this.windowHeigth
			);
		},
		listResult: function () {
			this.getResultClientByMouth();
			this.refreshList++;
		},
		netlink: function (data) {
			if (data.length == 0) {
				this.rowNum = 0;
			}
			this.refreshList++;
		},
	},

	methods: {
		getNetlinkTypeName(netlinkTypeId) {
			if (this.readOnly) {
				let foundNetlinkType = this.netlinkTypes.findIndex(
					(row) => row.id == netlinkTypeId
				);
				if (foundNetlinkType >= 0)
					return this.netlinkTypes[foundNetlinkType].name;
				else " ";
			} else {
				let foundNetlinkType = this.netlink_types.findIndex(
					(row) => row.id == netlinkTypeId
				);
				if (foundNetlinkType >= 0)
					return this.netlink_types[foundNetlinkType].name;
				else " ";
			}
		},
		getResultClientByMouth() {
			if (this.netlink.length > 0) {
				let listResultSplit = this.listResult.split(",");
				this.$http
					.get(
						this.$store.state.backendApiUrl + "netlink/getNetlinkClient",
						listResultSplit
					)
					.then((res) => {
						this.resultByMonth = res.data;
					})
					.catch((err) => {
						//console.log(err);
					});
			}
		},
		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		getAllNetlinkTypes() {
			this.$store.dispatch("getAllNetlinkTypes");
		},

		/**
		 * Fetch all the purchases
		 */
		getAllPurchases() {
			//////console.log("getAllNetlink BEGIN")
			this.$store.dispatch("getAllPurchases");
			//////console.log("getAllNetlink END")
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		/*
		 * getServiceIdToName(service_id){
		 *   let service_name = ""
		 *   let service = this.services.find(service => service.id == service_id)
		 *   service_name = service.name;
		 *   return service_name
		 * },
		 */

		/*
		 * getSocietyIdToName(society_id){
		 *   let society_name = ""
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name;
		 *   return society_name
		 * },
		 */

		/*
		 * getProviderIdToName(provider_id){
		 *   let provider_name = ""
		 *   let provider = this.providers.find(provider => provider.id == provider_id)
		 *   provider_name = provider.society;
		 *   return provider_name
		 * },
		 */

		getSocietyName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			society_name = society ? society.name : "";
			return society_name;
		},

		getPurchaseIdToSocietyName(purchase_id) {
			let society_name = "";
			let purchase = this.purchases.find(
				(purchase) => purchase.id == purchase_id
			);
			let society_id = purchase.contract_society_id;
			let society = this.societies.find((society) => society.id == society_id);
			society_name = society.name;
			return society_name;
		},

		getPurchaseIdToPurchaseDate(purchase_id) {
			let purchase_date = "";
			let purchase = this.purchases.find(
				(purchase) => purchase.id == purchase_id
			);
			purchase_date = purchase.bought_at;
			return purchase_date.substring(0, 10);
		},

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10);
			} else {
				return date_input;
			}
		},
		getAllServices() {
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties() {
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		deleteNetlink(netlink) {
			// let netlinkToDelete = new Netlink(netlink)
			Netlink.delete(netlink.id, (err, res) => {
				if (err)
					if (res) {
						////console.log(err)
						/*
						 *   this.$store.dispatch("getAllPurchases");
						 *   this.$store.dispatch("getAllServices");
						 */
						this.$emit("delete-line", netlink);
					}
			});
		},

		updateNetlink(netlink, society_name) {
			this.$emit("modify-netlink", [netlink, society_name]);
			// this.$emit("refresh-netlink");
		},

		displayValidationPopup(netlink) {
			this.netlinkToDelete = netlink;
			this.showValidationPopup = true;
		},

		displaySocietyImage(societyId) {
			let foundImage = this.societyImageList.find(
				(society) => society.id == societyId
			);
			if (foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},

		displaySocietyPopup(society) {
			////console.log("displaySocietyPopup", society)
			society.image = this.displaySocietyImage(society.id);
			this.$emit("show-society-popup", society);
		},
		displayContractPopup(contract) {
			////console.log("displayContractPopup", contract)
			this.$emit("show-contract-popup", contract);
		},

		accept() {
			this.deleteNetlink(this.netlinkToDelete);
			this.showValidationPopup = false;
		},

		decline() {
			this.netlinkToDelete = null;
			this.showValidationPopup = false;
		},
	},
};
</script>

<style>
.table-client {
	padding: 0 20px 20px 20px;
}
.thead-client {
	white-space: nowrap;
}
.center {
	justify-content: center;
}
#tb-netlink > .con-tablex.vs-table--content {
	overflow: visible;
}
#tb-netlink > div > .vs-con-tbody.vs-table--tbody {
	overflow: auto;
	max-height: 48vh;
}
.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
</style>
